import script from "./MallWishlistPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallWishlistPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallWishlistPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__